export default "__VITE_ASSET__3e4ca6b4__"